import { useMemo } from 'react';
import { findLast } from 'lodash-es';
import { ArrowHead } from 'seagull/icons';
import { addDays, isSameDay, startOfDay, isBefore } from 'date-fns';
import { IconButton, KeyboardDatePicker, TextButton } from 'seagull';
import { useIoContext } from "../../../../contexts";
import { getMaxFutureInvoiceDate } from "../../../../business-logic/billingLogic";
import styles from "./InvoiceNavigator.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function NavigationButtons(props) {
  const {
    options,
    value,
    onChange
  } = props;
  const is1stSelected = useMemo(() => isSameDay(value, options[0]), [value, options]);
  const nextOption = useMemo(() => options.find(opt => isBefore(value, opt)), [value, options]);
  const prevOption = useMemo(() => findLast(options, opt => isBefore(opt, value)), [value, options]);
  const prevDisabled = !prevOption;
  const nextDisabled = !nextOption;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.buttons,
    children: [/*#__PURE__*/_jsx(IconButton, {
      noPadding: true,
      disabled: prevDisabled,
      tooltip: {
        title: /*#__PURE__*/_jsx("div", {
          "data-testid": "to-prev-tooltip",
          children: prevDisabled ? 'No earlier invoices are available' : 'Previous invoice'
        }),
        placement: 'top'
      },
      "data-testid": "to-prev-invoice",
      onClick: () => prevOption && onChange(prevOption),
      children: /*#__PURE__*/_jsx(ArrowHead, {
        direction: "left"
      })
    }), /*#__PURE__*/_jsx(IconButton, {
      noPadding: true,
      disabled: nextDisabled,
      tooltip: {
        title: /*#__PURE__*/_jsx("div", {
          "data-testid": "to-next-tooltip",
          children: nextDisabled ? 'No later invoices are available' : 'Next invoice'
        }),
        placement: 'top'
      },
      "data-testid": "to-next-invoice",
      onClick: () => nextOption && onChange(nextOption),
      children: /*#__PURE__*/_jsx(ArrowHead, {
        direction: "right"
      })
    }), !is1stSelected && /*#__PURE__*/_jsx(TextButton, {
      underline: "none",
      "data-testid": "to-upcoming-invoice",
      onClick: () => onChange(options[0]),
      children: "Go to upcoming invoice"
    })]
  });
}
export default function InvoiceNavigator(props) {
  const {
    value,
    options,
    onChange
  } = props;
  const {
    getNow
  } = useIoContext();
  const minDate = useMemo(() => startOfDay(addDays(getNow(), 1)), []);
  const maxDate = useMemo(() => getMaxFutureInvoiceDate(getNow()), []);
  function isDayInOptions(day) {
    return !!day && options.some(opt => isSameDay(opt, day));
  }
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    children: [/*#__PURE__*/_jsx(KeyboardDatePicker, {
      size: "small",
      disableErrors: true,
      label: "Billing date",
      "data-testid": "invoice-picker",
      value: value,
      minDate: minDate,
      maxDate: maxDate,
      highlightDay: isDayInOptions,
      onChange: function (_onChange) {
        function onChange(_x) {
          return _onChange.apply(this, arguments);
        }
        onChange.toString = function () {
          return _onChange.toString();
        };
        return onChange;
      }(date => onChange(date || null))
    }), value && /*#__PURE__*/_jsx(NavigationButtons, {
      options: options,
      value: value,
      onChange: onChange
    })]
  });
}